import script from "./FlexRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./FlexRenderer.vue?vue&type=script&setup=true&lang=js"

import "./FlexRenderer.vue?vue&type=style&index=0&id=219f4758&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-219f4758"]])

export default __exports__